import React from "react";
import { playClickSound, playCloseSound } from "../../Sounds";

export const SHOP_ITEMS = [
  { id: "lucky_charm",         name: "Lucky Charm",          emoji: "🍀", cost: 120,  desc: "Next roll can't be Common",                    category: "boost"   },
  { id: "rare_surge",          name: "Rare Surge",           emoji: "⚡", cost: 350,  desc: "Next roll guaranteed Rare+",                   category: "boost"   },
  { id: "coin_multiplier",     name: "Coin Multiplier",      emoji: "💰", cost: 450,  desc: "Earn 2× coins for the next 10 rolls",          category: "coins"   },
  { id: "collection_insurance",name: "Collection Insurance", emoji: "🛡️", cost: 500,  desc: "Next duplicate gives 3× coins instead of 2×", category: "coins"   },
  { id: "streak_freeze",       name: "Streak Freeze",        emoji: "🧊", cost: 600,  desc: "Protects your streak if you miss a day",       category: "coins"   },
  { id: "hot_streak",          name: "Hot Streak",           emoji: "🔥", cost: 700,  desc: "Next 5 rolls bumped up one rarity tier",       category: "boost"   },
  { id: "mystery_box",         name: "Mystery Box",          emoji: "📦", cost: 900,  desc: "A random surprise — could be anything!",       category: "special" },
  { id: "epic_guarantee",      name: "Epic Guarantee",       emoji: "💜", cost: 1100, desc: "Next roll guaranteed Epic+",                   category: "boost"   },
  { id: "jackpot",             name: "Jackpot Mode",         emoji: "💎", cost: 1400, desc: "Next roll guaranteed Legendary+",              category: "boost"   },
  { id: "auto_roll",           name: "Auto Roll",            emoji: "🎰", cost: 1600, desc: "Automatically rolls 10 times, one by one",     category: "special" },
  { id: "bulk_roll",           name: "Bulk Roll",            emoji: "🎲", cost: 2000, desc: "Roll 10 times shown as a quick montage",       category: "special" },
];

const CATEGORY_LABELS = { boost: "⚡ Boosts", coins: "💰 Coins", special: "✨ Special" };
const DEAL_DISCOUNT   = 0.4;

function getDailyDeal() {
  const seed = new Date().toDateString();
  let h = 0;
  for (let i = 0; i < seed.length; i++) h = ((h << 5) - h) + seed.charCodeAt(i);
  h = Math.abs(h);
  const eligible  = SHOP_ITEMS.filter(i => i.category !== "special");
  const item      = eligible[h % eligible.length];
  const salePrice = Math.round(item.cost * (1 - DEAL_DISCOUNT));
  const now       = new Date();
  const midnight  = new Date(now); midnight.setHours(24, 0, 0, 0);
  const msLeft    = midnight - now;
  const hLeft     = Math.floor(msLeft / 3600000);
  const mLeft     = Math.floor((msLeft % 3600000) / 60000);
  const expiresIn = hLeft > 0 ? `${hLeft}h ${mLeft}m` : `${mLeft}m`;
  return { ...item, id: item.id + "_deal", originalId: item.id, salePrice, expiresIn };
}

function getDealKey()        { return "dealBought_" + new Date().toDateString(); }
function isDealBoughtToday() { return !!localStorage.getItem(getDealKey()); }
function markDealBought()    { localStorage.setItem(getDealKey(), "1"); }

function isActive(boosts, itemId) {
  if (itemId === "hot_streak")           return boosts.hot_streak > 0;
  if (itemId === "coin_multiplier")      return boosts.coin_multiplier > 0;
  if (itemId === "collection_insurance") return !!boosts.collection_insurance;
  if (itemId === "epic_guarantee")       return !!boosts.epic_guarantee;
  if (itemId === "streak_freeze")        return !!boosts.streak_freeze;
  return !!boosts[itemId];
}

function activeLabel(boosts, itemId) {
  if (itemId === "hot_streak")      return `🔥 ${boosts.hot_streak} roll${boosts.hot_streak === 1 ? "" : "s"} left`;
  if (itemId === "coin_multiplier") return `💰 ${boosts.coin_multiplier} roll${boosts.coin_multiplier === 1 ? "" : "s"} left`;
  if (itemId === "streak_freeze")   return "🧊 Freeze ready";
  return "✓ Active — next roll!";
}

export default function Shop({ coins, boosts, onBuy, onClose }) {
  const categories = ["boost", "coins", "special"];
  const deal       = getDailyDeal();
  const dealActive = isActive(boosts, deal.originalId);
  const dealAfford = coins >= deal.salePrice;
  const dealBought = isDealBoughtToday();

  function handleDealBuy() {
    playClickSound();
    markDealBought();
    onBuy({ ...deal, cost: deal.salePrice, id: deal.originalId });
  }

  return (
    <div className="modal-overlay" onClick={() => { playCloseSound(); onClose(); }}>
      <div className="modal-box shop-modal-box" onClick={e => e.stopPropagation()}>
        <h2 style={{ marginBottom: 4 }}>🛒 Luck Shop</h2>
        <p style={{ color: "var(--text-muted)", marginBottom: 16, fontSize: ".9rem" }}>
          You have <strong style={{ color: "var(--neon-gold)" }}>🪙 {coins}</strong> coins
        </p>

        {/* ── DAILY DEAL ── */}
        <div className={`shop-daily-deal${dealBought ? " shop-deal-claimed" : ""}`}>
          <div className="shop-deal-header">
            <span className="shop-deal-badge">{dealBought ? "✓ DEAL CLAIMED" : "🔥 DAILY DEAL"}</span>
            <span className="shop-deal-timer">{dealBought ? "New deal tomorrow" : `Expires in ${deal.expiresIn}`}</span>
          </div>
          {dealBought ? (
            <p style={{ textAlign: "center", color: "var(--text-muted)", fontSize: ".82rem", margin: "4px 0 0" }}>
              {deal.emoji} <strong style={{ color: "var(--text-main)" }}>{deal.name}</strong> — purchased today
            </p>
          ) : (
            <div className={`shop-item shop-deal-item${dealActive ? " active" : ""}${!dealAfford && !dealActive ? " cant-afford" : ""}`}>
              <div className="shop-emoji">{deal.emoji}</div>
              <div className="shop-name">{deal.name}</div>
              <div className="shop-desc">{deal.desc}</div>
              {dealActive && <div className="shop-active-label">{activeLabel(boosts, deal.originalId)}</div>}
              <div className="shop-deal-prices">
                <span className="shop-deal-original">🪙 {deal.cost}</span>
                <span className="shop-deal-sale">🪙 {deal.salePrice}</span>
                <span className="shop-deal-pct">-{Math.round(DEAL_DISCOUNT * 100)}%</span>
              </div>
              <button onClick={handleDealBuy} disabled={!dealAfford || dealActive}
                style={{ marginTop: 8, fontSize: ".85rem", padding: "8px 18px" }}>
                Buy Deal
              </button>
            </div>
          )}
        </div>

        {/* ── REGULAR ITEMS ── */}
        {categories.map(cat => {
          const items = SHOP_ITEMS.filter(i => i.category === cat);
          return (
            <div key={cat} className="shop-category">
              <div className="shop-category-label">{CATEGORY_LABELS[cat]}</div>
              <div className="shop-grid">
                {items.map(item => {
                  const active    = isActive(boosts, item.id);
                  const canAfford = coins >= item.cost;
                  const isSpecial = item.category === "special";
                  const isDealItem = item.id === deal.originalId;
                  return (
                    <div key={item.id} className={`shop-item${active ? " active" : ""}${!canAfford && !active ? " cant-afford" : ""}${isSpecial ? " special" : ""}${isDealItem && !dealBought ? " is-deal-item" : ""}`}>
                      {isDealItem && !dealBought && <div className="shop-deal-ribbon">Deal ↑</div>}
                      <div className="shop-emoji">{item.emoji}</div>
                      <div className="shop-name">{item.name}</div>
                      <div className="shop-desc">{item.desc}</div>
                      {active && <div className="shop-active-label">{activeLabel(boosts, item.id)}</div>}
                      <button onClick={() => { playClickSound(); onBuy(item); }} disabled={!canAfford || active}
                        style={{ marginTop: 10, fontSize: ".85rem", padding: "8px 18px" }}>
                        🪙 {item.cost}
                      </button>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}

        <button className="back-button" onClick={() => { playCloseSound(); onClose(); }} style={{ marginTop: 24 }}>Close</button>
      </div>
    </div>
  );
}